/* ==========================================================================
   OSERE — Míralo en acción

   Pista de miniaturas + visor con anterior/siguiente. Portado del snippet
   `product-videos-in-action.liquid`, que traía todo esto en un <script> por
   sección y con `window.pviaInitialized` como guardia global —lo que impide
   tener dos instancias en una página—.

   Tres cosas que el original no hacía y aquí sí:

   1. EL <video> NACE SIN `src`. Se crea al abrir y se DESTRUYE al cerrar. Con
      la fuente puesta, el navegador empieza a bajar el archivo aunque nadie
      pulse nada, y esta tienda va 70–80% móvil. Al cerrar no basta `pause()`:
      hay que quitar el src y llamar a load(), o el búfer sigue cayendo.
   2. Trampa de foco y foco devuelto. Sin ellas el tabulador se escapa detrás
      del visor y al cerrar aterriza al principio del documento.
   3. `play()` devuelve una promesa que RECHAZA si el navegador bloquea el
      autoplay. Sin `catch` salta un error no capturado y parece roto.
   ========================================================================== */

(function () {
  'use strict';

  var FOCO = 'a[href], button:not([disabled]), video[controls], [tabindex]:not([tabindex="-1"])';

  function montar(seccion) {
    var visor = seccion.querySelector('[data-os-va-visor]');
    var lienzo = seccion.querySelector('[data-os-va-lienzo]');
    var piezas = [].slice.call(seccion.querySelectorAll('[data-os-va-pieza]'));
    if (!visor || !lienzo || !piezas.length) return;
    if (seccion.dataset.osVaMontado) return;
    seccion.dataset.osVaMontado = '1';

    var prev = seccion.querySelector('[data-os-va-prev]');
    var next = seccion.querySelector('[data-os-va-next]');
    var cerrarBtn = seccion.querySelector('[data-os-va-cerrar]');
    var actual = 0;
    var devolverFoco = null;

    /* Con una sola pieza las flechas sobran y además confunden: parece que hay
       más y no hay. Se quitan del DOM, no se ocultan. */
    if (piezas.length < 2) {
      if (prev) prev.remove();
      if (next) next.remove();
      prev = next = null;
    }

    function vaciar() {
      var v = lienzo.querySelector('video');
      if (v) {
        v.pause();
        v.removeAttribute('src');
        v.load();
      }
      lienzo.innerHTML = '';
    }

    function pintar(i) {
      var pieza = piezas[i];
      var src = pieza && pieza.getAttribute('data-os-va-src');
      if (!src) return;
      actual = i;
      vaciar();

      var v = document.createElement('video');
      v.controls = true;
      v.playsInline = true;
      v.preload = 'metadata';
      v.setAttribute('controlslist', 'nodownload');
      v.className = 'os-va__video';
      var img = pieza.querySelector('img');
      if (img && img.currentSrc) v.poster = img.currentSrc;
      v.src = src;
      lienzo.appendChild(v);

      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function abrir(i, origen) {
      devolverFoco = origen || piezas[i];
      pintar(i);
      visor.hidden = false;
      document.documentElement.classList.add('os-va-abierto');
      (cerrarBtn || visor).focus();
    }

    function cerrar() {
      if (visor.hidden) return;
      visor.hidden = true;
      document.documentElement.classList.remove('os-va-abierto');
      vaciar();
      if (devolverFoco) devolverFoco.focus();
      devolverFoco = null;
    }

    function mover(paso) {
      pintar((actual + paso + piezas.length) % piezas.length);
    }

    piezas.forEach(function (pieza, i) {
      pieza.addEventListener('click', function () { abrir(i, pieza); });
    });

    if (prev) prev.addEventListener('click', function () { mover(-1); });
    if (next) next.addEventListener('click', function () { mover(1); });
    if (cerrarBtn) cerrarBtn.addEventListener('click', cerrar);

    /* Clic fuera cierra, pero solo si el objetivo ES el velo: sin esta
       comprobación, arrastrar el control de volumen y soltar fuera cierra. */
    visor.addEventListener('click', function (e) {
      if (e.target === visor) cerrar();
    });

    visor.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cerrar(); return; }
      if (e.key === 'ArrowLeft' && prev) { mover(-1); return; }
      if (e.key === 'ArrowRight' && next) { mover(1); return; }
      if (e.key !== 'Tab') return;

      var focos = visor.querySelectorAll(FOCO);
      if (!focos.length) return;
      var primero = focos[0];
      var ultimo = focos[focos.length - 1];
      if (e.shiftKey && document.activeElement === primero) {
        e.preventDefault();
        ultimo.focus();
      } else if (!e.shiftKey && document.activeElement === ultimo) {
        e.preventDefault();
        primero.focus();
      }
    });
  }

  function init(raiz) {
    var s = (raiz || document).querySelectorAll('[data-os-va]');
    for (var i = 0; i < s.length; i++) montar(s[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
  } else {
    init();
  }

  /* El personalizador reconstruye la sección al editarla y se lleva por delante
     los escuchadores. `data-os-va-montado` vive en el nodo, así que el nodo
     nuevo entra limpio y se vuelve a montar. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
